import { render } from "./AutoScaleVmProfile.vue?vue&type=template&id=35efe16f&scoped=true"
import script from "./AutoScaleVmProfile.vue?vue&type=script&lang=js"
export * from "./AutoScaleVmProfile.vue?vue&type=script&lang=js"

import "./AutoScaleVmProfile.vue?vue&type=style&index=0&id=35efe16f&scoped=true&lang=scss"

import exportComponent from "/jenkins/workspace/acs-centos8-pkg-builder/dist/rpmbuild/BUILD/cloudstack-4.19.3.0/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35efe16f"]])

export default __exports__